export const fyiPlatform = () => {
  let platform: string = 'Web';

  switch (process.env.REACT_APP_FYI_ENV) {
    case 'chrome':
      platform = 'Chrome Extension';
      break;
    case 'desktop':
      platform = 'Desktop';
      break;
  }

  return platform;
};
